module.exports = __webpack_public_path__ + "static/media/share-link-icon-teal.8494637f.svg";